export class AccountDto {
  id: number;
  permaId: string;
  name: string;
  email: string;
  firstVisit: number;
  lastVisit: number;
  emailsSent: number;
}

export class LicenceTypeDto {
  id: string;
  description: string;
  priceHuf: number;
  priceEur: number;
}

export class LicenceDto {
  id: number;
  permaId: string;
  startDate: string;
  endDate: string;
  paid: boolean;
  decision: boolean;
  decisionDate: number;
  description: string;
  typeId: string;
  accountId: number;
  type: LicenceTypeDto;
  account: AccountDto;

  year: number;
}

// export interface LicenceUnpaidDto {
//     accountPermaId: string;
//     year: number;
//     unpaid: number;
//     undecided: number;
// }

export class LicenceCreateDto {
  id: number;
  permaId: string;
  startDate: string;
  endDate: string;
  paid: boolean;
  decision: boolean;
  decisionDate: number;
  description: string;
  typeId: string;
  accountPermaId: string;
}
